function checkIfDateIsAlreadyFormatted(date) {
    return /^\d{2}\.\s\d{2}\.\s\d{4}\.\s\d{2}:\d{2}:\d{2}$/.test(date)
}

export {
    checkIfDateIsAlreadyFormatted
}